import { ReactElement, useMemo } from 'react';
import { TGoogleMapProps } from './GoogleMap.types';
import { StyleGoogleMap } from './GoogleMap.styles';
import { GOOGLE_MAP_KEY } from '@/shared/GoogleMap/domain/constants';

const GoogleMap = ({
    width,
    height,
    coordinates,
    address,
    allowFullScreen,
    title,
    maxWidth,
}: TGoogleMapProps): ReactElement => {
    const src = useMemo(
        () =>
            coordinates
                ? `https://www.google.com/maps/embed/v1/place?key=${GOOGLE_MAP_KEY}&q=${coordinates.lat},${coordinates.lng}`
                : `https://www.google.com/maps/embed/v1/place?key=${GOOGLE_MAP_KEY}&zoom=12&q=${
                      address != undefined
                          ? encodeURIComponent(address ?? '')
                                .replace(/#/g, '')
                                .trim()
                          : '+'
                  }`,
        [address, coordinates]
    );
    return (
        <StyleGoogleMap maxWidth={maxWidth || width} height={height}>
            <iframe
                id="google-maps"
                aria-label="google-map"
                width={width}
                height={height}
                frameBorder="0"
                title={title}
                src={src}
                allowFullScreen={allowFullScreen}
            />
        </StyleGoogleMap>
    );
};

export default GoogleMap;
